import * as React from 'react';
import {Input} from 'antd';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';

class HiddenFormItem extends React.Component<BaseFormItemProps, {}> {

  public render(): React.ReactNode {
    const {disabled} = this.props;
    return (
      <BaseFormItem
        {...this.props}
        input={<Input type="hidden" disabled={disabled}/>}
      />
    );
  }
}

export default HiddenFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/HiddenFormItem.tsx